export const AuthShell = ({ title, subtitle, children, testId }) => (
  <main className="relative flex min-h-[calc(100vh-4rem)] items-start justify-center px-4 py-10 sm:items-center sm:py-16" data-testid={testId}>
    <div className="rise w-full max-w-md rounded-3xl border border-[#E2E5DC] bg-white p-6 shadow-[0_20px_60px_-30px_rgba(15,45,94,0.35)] sm:p-10">
      <h1 className="text-3xl font-extrabold tracking-tight text-[#12201A] sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-[#495850]">{subtitle}</p>}
      <div className="mt-8">{children}</div>
    </div>
  </main>
);
